import { TbBrandApple, TbBrandWindows, TbDeviceMobile, TbGift, TbRobotOff } from "solid-icons/tb";
import { For, type JSX } from "solid-js";
import { MEETING_APPS } from "~/components/marketing/content";
import { LogoStack } from "~/components/marketing/LogoMark";
import { useI18n } from "~/i18n";

// Each platform in its own colour: Apple neutral, Windows in its blue, iPhone in iOS green.
const PLATFORMS = [
  { icon: TbBrandApple, class: "bg-[#e5e7eb] text-[#111827] dark:bg-white/15 dark:text-white" },
  { icon: TbBrandWindows, class: "bg-[#dbeafa] text-[#0078D4] dark:bg-[#0078D4]/25 dark:text-[#4da3ff]" },
  { icon: TbDeviceMobile, class: "bg-[#dcf5e3] text-[#1f8f3e] dark:bg-[#34C759]/20 dark:text-[#4ade80]" },
];

const Group = (props: { children: JSX.Element }) => (
  <li class="flex items-center gap-2.5 rounded-full border border-primary-border bg-tile/80 py-1.5 ps-1.5 pe-4 whitespace-nowrap shadow-sm backdrop-blur">
    {props.children}
  </li>
);

/** The hero's proof line: where Chief runs, what it works with, and the two promises that matter first. */
export const HeroProof = () => {
  const { t } = useI18n();
  return (
    <ul class="mt-8 flex flex-col items-center gap-3 text-sm text-secondary-text sm:grid sm:grid-cols-[repeat(2,auto)] sm:justify-center sm:justify-items-center lg:flex lg:flex-row lg:flex-nowrap">
      <Group>
        <span class="flex -space-x-1.5">
          <For each={PLATFORMS}>
            {(platform) => (
              <span class={`grid size-7 place-items-center rounded-full ring-2 ring-tile ${platform.class}`}>
                <platform.icon class="size-4" aria-hidden="true" />
              </span>
            )}
          </For>
        </span>
        {t("marketing.home.hero.platforms_label")}
      </Group>
      <Group>
        <LogoStack logos={MEETING_APPS} />
        <span>
          {t("marketing.home.hero.works_with_app")}
          <span class="sr-only">: {MEETING_APPS.map((app) => app.name).join(", ")}</span>
        </span>
      </Group>
      <Group>
        <span class="grid size-7 place-items-center rounded-full bg-success/15 text-marketing-success">
          <TbRobotOff class="size-4" aria-hidden="true" />
        </span>
        {t("marketing.home.hero.no_bot_short")}
      </Group>
      <Group>
        <span class="grid size-7 place-items-center rounded-full bg-accent/15 text-accent-text">
          <TbGift class="size-4" aria-hidden="true" />
        </span>
        {t("marketing.home.hero.free")}
      </Group>
    </ul>
  );
};
